import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';
import { pdfBase64ObjectUrl } from '@/api/SistemaDKP/documento-fiscal.client';

export default class PTC_Notas {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async retornaNotas(queries = null) {
    let query = '';
    if (queries === undefined || queries === null || queries === '') {
      query = 'ptc/retornanotas?';
    }

    if (queries && queries.estabelecimentoid) {
      query = `ptc/retornanotas?estabelecimentoid=${queries.estabelecimentoid}`;
    }

    if (queries && queries.notafiscalnumero) {
      if (queries.estabelecimentoid) {
        query = `${query}&notafiscalnumero=${queries.notafiscalnumero}`;
      } else {
        query = `ptc/retornanotas?notafiscalnumero=${queries.notafiscalnumero}`;
      }
    }

    if (queries && queries.notafiscalserie) {
      if (queries.estabelecimentoid || queries.notafiscalnumero) {
        query = `${query}&notafiscalserie=${queries.notafiscalserie}`;
      } else {
        query = `ptc/retornanotas?notafiscalserie=${queries.notafiscalserie}`;
      }
    }

    if (queries && queries.DataEmissaoDe && queries.DataEmissaoAte) {
      if (queries.notafiscalnumero || queries.notafiscalserie) {
        query = `${query}&DataEmissaoDe=${queries.DataEmissaoDe}`;
        query = `${query}&DataEmissaoAte=${queries.DataEmissaoAte}`;
      } else {
        query = `ptc/retornanotas?DataEmissaoDe=${queries.DataEmissaoDe}`;
        query = `${query}&DataEmissaoAte=${queries.DataEmissaoAte}`;
      }
    }

    // Filtro pontual por pedido (usado na linha do tempo do detalhe do pedido PTC).
    if (queries && queries.pedidoid) {
      query = query
        ? `${query}&pedidoid=${queries.pedidoid}`
        : `ptc/retornanotas?pedidoid=${queries.pedidoid}`;
    }

    if (queries && queries.etapaPedido !== undefined) {
      query = `${query || 'ptc/retornanotas?'}${query ? '&' : ''}etapaPedido=${encodeURIComponent(queries.etapaPedido)}`;
    }
    try {
      const result = await this.api.get(query);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar notas');
    }
  }

  async retornaDanf(queries) {
    const query = `ptc/danf?EstabelecimentoId=${queries.estabelecimentoid}&NotaFiscalNumero=${String(queries.notafiscalnumero).padStart(7, '0')}&notafiscalserie=${queries.notafiscalserie}`;
    // console.log('Estabelecimento id: ', queries.estabelecimentoid)
    // console.log('Número nota fiscal: ', queries.notafiscalnumero)
    // console.log('Série nota fiscal: ', queries.notafiscalserie)
    // let query = `ptc/danf?EstabelecimentoId=1&NotaFiscalNumero=0000003&notafiscalserie=1`
    try {
      const result = await this.api.get(query);
      if (!result.data?.arquivoPDF) throw new Error('O ERP não retornou PDF para esta nota fiscal.');
      return pdfBase64ObjectUrl(result.data.arquivoPDF);
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar DANF');
    }
  }

  async retornaXmlNota(queries) {
    // let query = `ptc/xmlnota?EstabelecimentoId=${queries.estabelecimentoid}&NotaFiscalNumero=${queries.notafiscalnumero}&notafiscalserie=${queries.notafiscalserie}`
    console.log('Estabelecimento id: ', queries.estabelecimentoid);
    console.log('Número nota fiscal: ', queries.notafiscalnumero);
    console.log('Série nota fiscal: ', queries.notafiscalserie);
    const query = 'ptc/xmlnota?EstabelecimentoId=1&NotaFiscalNumero=0000003&notafiscalserie=1';
    try {
      const result = await this.api.get(query);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar XML da nota');
    }
  }
}
